import ButtonVariant from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ButtonVariant';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import { useBuilderConfigContext } from 'hb-builder/hooks';
import { BUTTON_VARIANT_OPTIONS } from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';

export const BUTTON_VARIANT_DEFAULT_VALUE = BUTTON_VARIANT_OPTIONS.PRIMARY;

const NetworkMode = ({ item, settingProps }) => {
  const {
    features: {
      button: { includeInversed },
    },
  } = useBuilderConfigContext();
  const buttons = item.children || [item];
  const numberButtons = buttons.length;

  return (
    <>
      {numberButtons > 1 && (
        <InputTitle
          boxProps={{ mb: 3 }}
          label={s__('Builder|Type of button')}
          position="top"
        />
      )}
      {buttons.map((button, index) => (
        <ButtonVariant
          {...settingProps}
          key={`settingVariant-${button.id}`}
          defaultValue={
            button.attributes.variant || BUTTON_VARIANT_DEFAULT_VALUE
          }
          item={button}
          includeInversed={includeInversed}
          title={
            numberButtons > 1
              ? s__('Builder|Button %{index}').i__({
                  index: (index + 1).toString(),
                })
              : s__('Builder|Type of button')
          }
        />
      ))}
    </>
  );
};

export default NetworkMode;
